export default __webpack_public_path__ + "static/media/Erin_Mayland_AHV_In_Moms_We_Trust.b8240ba5.jpg";